import React from "react"
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";

function DetailsSection({ title, subtitle }) {
  const data = useStaticQuery(graphql`
  query {
    file(relativePath: { eq: "assets/slack.png" }) {
      childImageSharp {
        fluid(maxWidth: 520) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`)
  return (
    <div className="section">
      <div className="container">
        <div className="section-image">
          <Img style={{ margin: "0 -3% 8px -3%" }} fluid={data.file.childImageSharp.fluid} />
        </div>
        <h2>{title || <span>Slack, Zapier &<br />Push notifications</span>}</h2>
        <div className="subtitle">{subtitle || "Configure your notifications to be delivered to exactly where you want them."}
        </div>
      </div>
    </div>
  );
}

export default DetailsSection;